// src/components/document-type/ServiceGiseongAutoFill.jsx
import { useEffect } from "react";

// ✅ 기성계 붙임 목록 (기본)
const GISEONG_ATTACHMENTS = [
  { id: 1,  name: "기성계",                count: 1 },
  { id: 2,  name: "기성내역서",            count: 1 },
  { id: 3,  name: "청구서",                count: 1 },
  { id: 4,  name: "기성검사원",            count: 1 },
  { id: 5,  name: "급여내역서",            count: 1 },
  { id: 6,  name: "개인별근무카드",        count: 2 },
  { id: 7,  name: "4대보험 완납증명서",    count: 1 },
  { id: 8,  name: "납세증명서",            count: 1 },
  { id: 9,  name: "지방세 납세증명서",     count: 1 },
  { id: 10, name: "통장사본",              count: 1 },
];

const SCIENCECUBE_ATTACHMENTS = [ // 큐브, 금천문집, 독산문집, 청소년상담, 진로진학(독산), 평생학습관, 
  { id: 1,  name: "기성계",                count: 1 },
  { id: 2,  name: "기성내역서",            count: 1 },
  { id: 3,  name: "청구서",                count: 1 },
  { id: 4,  name: "기성검사원",            count: 1 },
  { id: 5,  name: "급여내역서",            count: 1 },
  { id: 6,  name: "개인별근무카드",        count: 1 },  // ← 1부
  { id: 7,  name: "4대보험 완납증명서",    count: 1 },
  { id: 8,  name: "납세증명서",            count: 1 },
  { id: 9,  name: "지방세 납세증명서",     count: 1 },
  { id: 10, name: "통장사본",              count: 1 },
];

// ✅ 제출형 정비 시 사용자가 실측 확인한 최신 부수로 갱신(과거 4/1/1/3부 → 24/2/2/7부 등)
const ANYANGCHEON_ATTACHMENTS = [
  { id: 1,  name: "기성계",                              count: 1 },
  { id: 2,  name: "기성내역서",                          count: 2 },
  { id: 3,  name: "청구서",                              count: 1 },
  { id: 4,  name: "기성검사원",                          count: 1 },
  { id: 5,  name: "급여내역서",                          count: 2 },
  { id: 6,  name: "개인별근무카드",                      count: 24 },
  { id: 7,  name: "안전보건 교육일지",                   count: 2 },
  { id: 8,  name: "안양천 편의시설 및 물놀이장 과업수행", count: 7 },
  { id: 9,  name: "사업장 4대 사회보험 완납증명서",      count: 1 },
  { id: 10, name: "납세증명서",                          count: 1 },
  { id: 11, name: "지방세 납세증명서",                   count: 1 },
  { id: 12, name: "통장사본",                            count: 1 },
];

const JEONDAN_ATTACHMENTS = [ // 불법전단지
  { id: 1,  name: "기성계",                count: 1 },
  { id: 2,  name: "기성내역서",            count: 1 },
  { id: 3,  name: "청구서",                count: 1 },
  { id: 4,  name: "기성검사원",            count: 1 },
  { id: 5,  name: "급여내역서",            count: 1 },
  { id: 6,  name: "개인별근무카드",        count: 6 },  // ← 6부
  { id: 7,  name: "4대보험 완납증명서",    count: 1 },
  { id: 8,  name: "납세증명서",            count: 1 },
  { id: 9,  name: "지방세 납세증명서",     count: 1 },
  { id: 10, name: "통장사본",              count: 1 },
];

const JAKEUNDOSEO_ATTACHMENTS = [ // 작은도서관
  { id: 1, name: "기성계",                count: 1 },
  { id: 2, name: "기성내역서",            count: 1 },
  { id: 3, name: "청구서",                count: 1 },
  { id: 4, name: "기성검사원",            count: 1 },
  { id: 5, name: "급여내역서",            count: 1 },
  { id: 6, name: "4대보험 완납증명서",    count: 1 },
  { id: 7, name: "납세증명서",            count: 1 },
  { id: 8, name: "지방세 납세증명서",     count: 1 },
  { id: 9, name: "통장사본",              count: 1 },
];

const GONGDAN_BONBU_ATTACHMENTS = [
  { id: 1,  name: "기성금청구서",                    count: 1 },
  { id: 2,  name: "기성확인내역서",                  count: 1 },
  { id: 3,  name: "기성부분 감독조서",               count: 1 },
  { id: 4,  name: "급여내역서",                      count: 1 },
  { id: 5,  name: "계좌이체 의뢰서",                 count: 1 },
  { id: 6,  name: "납세증명서",                      count: 1 },
  { id: 7,  name: "지방세 납세증명서",               count: 1 },
  { id: 8,  name: "4대보험 완납증명서",              count: 1 },
  { id: 9,  name: "통장사본",                        count: 1 },
  { id: 10, name: "전자세금계산서(별도 전자전송)",   count: 1 },
];


// ✅ 용역 수입기안 "청구형" 공단 계약 전용 팩토리 — 사업장별로 계약ID/계약명칭/참조표기만
// 다르고 나머지(붙임 10종, 표 구조, 청구/공문 문구 골격)는 전부 동일해서 팩토리로 생성.
// 제목/본문은 여기서 세팅하지 않는다 — 회차(N)는 workMonth의 월과 무관하게 별도
// "기성계 불러오기"(DraftDocumentNew.jsx)로 확정되므로, 그 시점에 제목이 세팅된다.
export function makeYongyeokClaimTemplate({ siteKey, contractId, contractName, referenceLabel = "" }) {
  return {
    displayName: null,
    bodyVerb: "청구하고자",
    attachments: GONGDAN_BONBU_ATTACHMENTS,
    tableType: "yongyeok_claim",
    siteKey,
    contractId,
    contractName,
    referenceLabel,
  };
}

// ✅ 청구형 7개 사업장 키 목록 — 목록 2행 전개(DraftDocumentList.jsx)에서
// "이 문서가 청구형인가"를 template_code로 판별할 때 사용
export const YONGYEOK_CLAIM_SITE_KEYS = [
  "yongyeok_claim_geumnarae_munche",
  "yongyeok_claim_gumin_munche",
  "yongyeok_claim_doksan_badminton",
  "yongyeok_claim_gongdan_bonbu",
  "yongyeok_claim_green_butcher",
  "yongyeok_claim_jonghap_welfare",
  "yongyeok_claim_geumbit_fitness",
];

// ✅ 용역 수입기안 "제출형"(기성계 제출) 전용 팩토리 — 청구형과 달리 표/회차/자동계산이
// 없고, 본문 한 문장 + 붙임 목록이 전부. 제목·본문은 workMonth의 월에서 바로 유도되므로
// (기성계 재조회 불필요) ServiceGiseongAutoFill 이펙트에서 즉시 세팅한다.
// ✅ contractId — gisung_gye.GisungContract PK. 제출형도 전부 기성계 계약 1건에
// 매핑되지만(2026-07 기성계 관리 화면 실측: 전 20계약이 실제로 입력되고 있음),
// 지금까지는 청구형(내부기안+공문 페어) 전용 필드였다가 "기성계 불러오기 모달
// 20곳 전체 조회" 작업에서 처음 채워짐 — 아래 각 항목의 serviceName/recipient를
// GisungContract.service_name/institution과 대조해 1:1 매칭했다(전수 확인 완료).
export function makeYongyeokSubmitTemplate({ siteKey, contractId, serviceName, recipient, honorific, viaLabel = "", attachments }) {
  return {
    displayName: null,
    bodyVerb: "제출하고자",
    tableType: "yongyeok_submit",
    siteKey,
    contractId,
    serviceName,
    recipient,
    honorific,
    viaLabel,
    attachments,
  };
}

// ✅ 제출형 13개 사업장 키 목록 — 목록 2행 전개 판별용(청구형과 동일한 용도)
export const YONGYEOK_SUBMIT_SITE_KEYS = [
  "yongyeok_submit_geumcheon_youth_center",
  "yongyeok_submit_doksan_youth_center",
  "yongyeok_submit_lifelong_learning",
  "yongyeok_submit_science_cube",
  "yongyeok_submit_career_center",
  "yongyeok_submit_youth_counseling",
  "yongyeok_submit_veterans_office",
  "yongyeok_submit_illegal_flyers",
  "yongyeok_submit_anyangcheon",
  "yongyeok_submit_small_library",
  "yongyeok_submit_culture_foundation",
  "yongyeok_submit_gu_library_guide",
  "yongyeok_submit_recycling_collection",
];

// ✅ 거래처별 표시 이름 및 본문 문구 매핑
// ✅ export — DraftDocumentNew.jsx가 청구형(yongyeok_claim) vendor 선택 시
// contractId/contractName/referenceLabel을 조회하기 위해 재사용
export const VENDOR_CONFIG = {
  "고품질 재활용 자원 수거(용역)": makeYongyeokSubmitTemplate({
    siteKey: "yongyeok_submit_recycling_collection",
    contractId: 18,
    serviceName: "고품질 재활용 자원 위탁 수거 용역",
    recipient: "금천구청",
    honorific: "귀 청",
    attachments: GISEONG_ATTACHMENTS,  // 개인별근무카드 2부(기본 목록)
  }),
  "보훈단체 사무실(용역)": makeYongyeokSubmitTemplate({
    siteKey: "yongyeok_submit_veterans_office",
    contractId: 13,
    serviceName: "보훈단체 사무실 환경정비 용역",
    recipient: "금천구청",
    honorific: "귀 청",
    attachments: GISEONG_ATTACHMENTS,  // 개인별근무카드 2부(기본 목록)
  }),
  "금천사이언스큐브(용역)": makeYongyeokSubmitTemplate({
    siteKey: "yongyeok_submit_science_cube",
    contractId: 15,
    serviceName: "금천사이언스큐브 청소용역",
    recipient: "금천구청",
    honorific: "귀 청",
    // ✅ 원본 PDF는 "년도" 표기였으나 전 세트 공통 규칙("년" 통일)에 맞춰 정정
    attachments: SCIENCECUBE_ATTACHMENTS,
  }),
  // ⚠️ vendor 키 실측 수정 — 기존 "안양천 편의시설물(용역)"은 실제 partner_name
  // "안양천 편의시설(용역)"(물 없음)과 어긋나 있어 자동채움이 매칭된 적이 없었음
  "안양천 편의시설(용역)": makeYongyeokSubmitTemplate({
    siteKey: "yongyeok_submit_anyangcheon",
    contractId: 1,
    serviceName: "안양천 편의시설물 유지관리용역",
    recipient: "금천구청 재무과 주무관",
    honorific: "귀 청",
    viaLabel: "금천구청 치수과 주무관",  // ⚠️ 13종 중 유일하게 경유 사용
    attachments: ANYANGCHEON_ATTACHMENTS,
  }),
  "금천청소년문화의집(용역)": makeYongyeokSubmitTemplate({
    siteKey: "yongyeok_submit_geumcheon_youth_center",
    contractId: 17,
    serviceName: "금천청소년문화의집 미화 용역",
    recipient: "금천청소년문화의집",
    honorific: "귀 사",
    attachments: SCIENCECUBE_ATTACHMENTS,  // 개인별근무카드 1부
  }),
  "독산청소년문화의집(용역)": makeYongyeokSubmitTemplate({
    siteKey: "yongyeok_submit_doksan_youth_center",
    contractId: 16,
    serviceName: "독산청소년문화의집 미화 용역",
    recipient: "독산청소년문화의집",
    honorific: "귀 사",
    attachments: SCIENCECUBE_ATTACHMENTS,
  }),
  "금천청소년상담복지센터(용역)": makeYongyeokSubmitTemplate({
    siteKey: "yongyeok_submit_youth_counseling",
    contractId: 19,
    serviceName: "금천구청소년상담복지센터 미화 용역",  // ← 금천"구"
    recipient: "금천구청소년상담복지센터",
    honorific: "귀 기관",  // ⚠️ 원본 "귀 청"에서 변경(사용자 확정) — 수신처가 구청이 아니라 센터 자체이므로
    attachments: SCIENCECUBE_ATTACHMENTS,
  }),
  "금천진로진학 독산센터(용역)": makeYongyeokSubmitTemplate({
    siteKey: "yongyeok_submit_career_center",
    contractId: 12,
    serviceName: "금천진로진학지원센터(독산센터) 청소용역",
    recipient: "금천구청",
    honorific: "귀 청",
    attachments: SCIENCECUBE_ATTACHMENTS,
  }),
  "금천평생학습관(용역)": makeYongyeokSubmitTemplate({
    siteKey: "yongyeok_submit_lifelong_learning",
    contractId: 11,
    serviceName: "금천평생학습관(독산) 청소용역",
    recipient: "금천구청",
    honorific: "귀 청",
    attachments: SCIENCECUBE_ATTACHMENTS,
  }),
  "불법전단지(용역)": makeYongyeokSubmitTemplate({
    siteKey: "yongyeok_submit_illegal_flyers",
    contractId: 14,
    serviceName: "불법전단지 정비 용역",
    recipient: "금천구청",
    honorific: "귀 청",
    attachments: JEONDAN_ATTACHMENTS,  // 개인별근무카드 6부
  }),

  "금천문화재단 작은도서관 안내(용역)": makeYongyeokSubmitTemplate({
    siteKey: "yongyeok_submit_small_library",
    contractId: 4,
    serviceName: "작은도서관 주말 용역",
    recipient: "재단법인 금천문화재단",
    honorific: "귀 재단",
    attachments: JAKEUNDOSEO_ATTACHMENTS,  // 붙임 B(9종, 근무카드 제외)
  }),
    
  // ⚠️ vendor 키 실측 수정 — 기존 "금천문화재단 도서관 미화(용역)"은 실제 partner_name
  // "금천문화재단 도서관 미화 (용역)"(괄호 앞 공백 있음)과 어긋나 있어 매칭된 적이 없었음
  "금천문화재단 도서관 미화 (용역)": makeYongyeokSubmitTemplate({
    siteKey: "yongyeok_submit_culture_foundation",
    contractId: 2,
    serviceName: "재단법인 금천문화재단 청소용역",
    recipient: "재단법인 금천문화재단",
    honorific: "귀 재단",
    attachments: JAKEUNDOSEO_ATTACHMENTS,  // 붙임 B(9종)
  }),

  "금천문화재단 도서관 안내(용역)": makeYongyeokSubmitTemplate({
    siteKey: "yongyeok_submit_gu_library_guide",
    contractId: 3,
    serviceName: "금천구립도서관(독산,가산,시흥) 안내 도움 용역",
    recipient: "재단법인 금천문화재단",
    honorific: "귀 재단",
    attachments: JAKEUNDOSEO_ATTACHMENTS,  // 붙임 B(9종)
  }),
  "금나래문화체육센터(용역)": makeYongyeokClaimTemplate({
    siteKey: "yongyeok_claim_geumnarae_munche",
    contractId: 5,
    contractName: "2026년 금나래문화체육센터 시설물 유지관리 용역",
    referenceLabel: "금나래문화체육센터",
  }),
  "금천구민문화체육센터(용역)": makeYongyeokClaimTemplate({
    siteKey: "yongyeok_claim_gumin_munche",
    contractId: 6,
    contractName: "2026년 금천구민문화체육센터 시설물 유지관리 용역",
    referenceLabel: "금천구민문화체육센터",
  }),
  "독산배드민턴 체육관(용역)": makeYongyeokClaimTemplate({
    siteKey: "yongyeok_claim_doksan_badminton",
    contractId: 10,
    contractName: "2026년 독산배드민턴체육관 시설물 유지관리 용역",
    referenceLabel: "독산배드민턴체육관",
  }),
  "그린푸줏간(용역)": makeYongyeokClaimTemplate({
    siteKey: "yongyeok_claim_green_butcher",
    contractId: 20,
    contractName: "2026년 그린푸줏간 시설물 유지관리 용역",
    referenceLabel: "우시장 그린푸줏간",  // ⚠️ 사업장명과 다름 — 실제 참조표기 명시값
  }),
  "금천종합복지타운(용역)": makeYongyeokClaimTemplate({
    siteKey: "yongyeok_claim_jonghap_welfare",
    contractId: 7,
    contractName: "2026년 금천종합복지타운 시설물 유지관리 용역",
    referenceLabel: "금천종합복지타운",
  }),
  "금빛휘트니스센터(용역)": makeYongyeokClaimTemplate({
    siteKey: "yongyeok_claim_geumbit_fitness",
    contractId: 8,
    contractName: "2026년 금빛휘트니스센터 시설물 유지관리 용역",
    referenceLabel: "금빛휘트니스센터",
  }),
  "금천구시설관리공단 본부(용역)": makeYongyeokClaimTemplate({
    siteKey: "yongyeok_claim_gongdan_bonbu",
    contractId: 9,
    contractName: "2026년 공단본부 미화 용역",
    referenceLabel: "",  // ✅ 원본 공문(260702-025호)엔 참조 줄 자체가 없음
  }),

  // 나중에 다른 거래처 추가 시 여기에 추가
};

// ② props에 setTableType 추가
export default function ServiceGiseongAutoFill({
  documentType,
  category,
  detailOption,
  vendor,
  workMonth,
  setTitle,
  setDesc,
  setAttachments,
  setTableType,   // ✅ 추가
  setTemplateField,  // ✅ 제출형(yongyeok_submit) 전용 — 수신처/호칭/경유/용역명 저장
}) {
  useEffect(() => {
    const isGiseong =
      documentType === "income_draft" &&
      category === "용역사업" &&
      detailOption === "기성계";

    // ✅ 조건이 더 이상 성립하지 않으면(카테고리 변경 등) tableType을 반드시 초기화한다 —
    // 이전엔 여기서 그냥 return만 해서, 한 번 "용역사업/기성계"로 tableType이
    // "yongyeok_claim"/"yongyeok_submit"으로 세팅된 뒤 카테고리를 바꿔도 그대로 남아
    // 소독(환경/소독) 등 다른 카테고리의 렌더링까지 용역 청구형/제출형으로 오염시키는
    // 회귀가 있었다(같은 페이지 인스턴스에서 재선택하는 경우에 한함).
    if (!isGiseong || !vendor || !workMonth) {
      if (setTableType) setTableType(null);
      return;
    }

    const config = VENDOR_CONFIG[vendor];
    if (!config) {
      if (setTableType) setTableType(null);
      return;
    }

    const [year, month] = workMonth.split("-");
    if (!year || !month) return;
    const monthNum = parseInt(month, 10);

    // ✅ 청구형(yongyeok_claim)은 제목/본문을 여기서 세팅하지 않는다 — 회차(N)가
    // workMonth의 월과 무관하고 별도 "기성계 불러오기"로 확정되므로, DraftDocumentNew.jsx의
    // 기성계 선택 핸들러가 제목/본문을 세팅한다.
    if (config.tableType === "yongyeok_claim") {
      // 붙임/tableType만 아래 공통 로직에서 세팅됨 — 제목/본문은 건너뜀
    } else if (config.tableType === "yongyeok_submit") {
      // ✅ 제출형 — 회차 개념이 없어 workMonth의 월에서 바로 제목/본문 유도(재조회 불필요).
      // 공문 전용 문구(수신/호칭/경유)는 IncomeProposalPreview.jsx가 templateState에서 읽어
      // 렌더링 시점에 조립하므로, 여기서는 그 원본 값만 templateState에 저장해둔다.
      const titleText = `${year}년 ${config.serviceName} ${monthNum}월 기성계 제출`;
      const descText  = `${year}년 ${config.serviceName} ${monthNum}월 기성계를 붙임과 같이 ${config.bodyVerb} 합니다.`;
      setTitle(titleText);
      setDesc(descText);
      if (setTemplateField) {
        setTemplateField("yongyeokSubmitServiceName", config.serviceName);
        setTemplateField("yongyeokSubmitRecipient", config.recipient || "");
        setTemplateField("yongyeokSubmitHonorific", config.honorific || "");
        setTemplateField("yongyeokSubmitViaLabel", config.viaLabel || "");
      }
    } else if (config.displayName) {
      // ✅ displayName 있을 때만 제목/본문 자동완성
      const titleText = `${year}년 ${config.displayName} ${monthNum}월 기성계 제출`;
      const descText  = `${year}년 ${config.displayName} ${monthNum}월 기성계를 붙임과 같이 ${config.bodyVerb} 합니다.`;
      setTitle(titleText);
      setDesc(descText);
    } else if (config.titleTemplate) {  // ✅ 추가
      setTitle(config.titleTemplate(year, monthNum));
      setDesc(`${config.titleTemplate(year, monthNum)}을 아래와 같이 ${config.bodyVerb} 합니다.`);
    }
    // ✅ 붙임은 항상 세팅
    setAttachments(config.attachments ?? GISEONG_ATTACHMENTS);

    // ✅ tableType 세팅 (없으면 null로 초기화)
    if (setTableType) {
      setTableType(config.tableType ?? null);
    }

  }, [documentType, category, detailOption, vendor, workMonth]);

  return null;
}
